export const MODAL_STATUS = 'SV_MODAL_STATUS'
export const CHAT_COUNT = 'SV_CHAT_COUNT'
